import { Injectable, inject } from '@angular/core';

import { Actions, createEffect } from '@ngrx/effects';

import { AuthService } from '@views/misc/auth/auth.service';

import { FilesService } from '@core/utilities/file/files.service';

import * as actions from './files.actions';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private filesService = inject(FilesService);
  private authService = inject(AuthService);

  fetchItem$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: action => this.filesService.fetchList(action.payload),
      errorMessage: 'Sorry, there has been an error fetching your files',
      startAction: actions.fileFetchListStart,
      successAction: actions.fileFetchListSuccess,
      failAction: actions.fileFetchListFail,
    }),
  );

  addItem$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: action => this.filesService.uploadFile(action.payload),
      errorMessage: 'Sorry, there has been an error uploading your file',
      successMessage: 'Your file has been uploaded',
      startAction: actions.fileAddItemStart,
      successAction: actions.fileAddItemSuccess,
      failAction: actions.fileAddItemFail,
      useMergeMap: true,
    }),
  );
}
